import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- @glint-nocheck --}}\n{{#if @hasLabel}}\n  <@labelComponent />\n{{/if}}\n{{yield}}\n<@errorsComponent />\n<@helpTextComponent />", {
  moduleName: "ember-bootstrap/components/bs-form/element/layout/inline.hbs"
});